import Card from "./Card"
import SmallHeadingComponent from "./SmallHeadingComponent"
import Link from "./Link"

function PsychoEducationBox() {

    function link() {
        return process.env.REACT_APP_PSYCHOEDUCATION_LINK ?? "https://www.pokal-kolleg.de/scrivito/door-studie/schulungsmaterialien/66931ebf283b7cfd"
    }

    return (
        <Card>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>
                    Schulungsunterlagen
                </SmallHeadingComponent>
                <div className={"flex"}>
                    <span>{"Ihre Schulungsunterlagen finden Sie"}</span>
                    <Link href={link()} target="_blank">
                        <span className={"ml-1"}>hier</span>
                    </Link>
                    <span>.</span>
                </div>
            </div>
        </Card>
    )
}

export default PsychoEducationBox